<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="psu" label-position="right" class="mainfrom">
        <el-form-item label="项目编号" class="from-value">
          {{psu.projectcode}}
        </el-form-item>
        <el-form-item label="项目名称" class="from-value">
          {{psu.projectname}}
        </el-form-item>
        <el-form-item label="报名文件">
          <div class="file">
            <upload-btn @changed='setfile' text="上传报名文件"></upload-btn>
            <div v-if="appendList.length" class="filelist">
              <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
                <div class="btn" @click="delappend(item)"><span>删除</span></div>
              </div>
            </div>
          </div>
          <!--<el-link v-for="(append,index) in appendList" type="primary" @click="downFile (append.appendurl)"  :key="index" target="_blank">{{append.appendfilename}}</el-link>-->
        </el-form-item>

      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadBtn from '../common/uploadBtn'

  export default {
    name: "psuBmPayForm",
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        psu: this.$route.params.form,
        psuisopenList: [],
        psuflgList: [],
        appendList: []
      }
    },
    created () {
      this.init()
    },
    activated () {
      this.init()
    },
    watch: {},
    filters: {},
    components: {uploadBtn},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.psu = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        await this.getAppends()
      },
      delappend(file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      async getAppends () {
        this.appendList = await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: {appendfromid: this.psu.psuid, appendfromtype: 10}
        })
      },
      async setfile  (path,filename) {
        let append = {
          appendid: 0,
          appendfromid: this.psu.psuid,
          appendfromtype: 10,
          appendtype: 100,
          appendseq: this.appendList.length+1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr,'')
        }
        this.appendList.push(append)
      },
      async save () {
        let data = await request({
          url: '/xmgl/project/savePsuAppends',
          method: "post",
          data: {psuid: this.psu.psuid, appends: this.appendList}
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('附件上传成功')
        } else {
          this.$message.error('附件上传失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
  .file {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
</style>
